module.exports = __webpack_public_path__ + "static/media/plantilla_mails.92522633.txt";